import { Button, Dropdown, Form, Icon, Input, Menu, message, Modal, Select } from 'antd';
import * as React from 'react';
import withStyles from 'react-jss';
import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { disableLoadTracking, enableLoadTracking, fetchTrackingData } from 'src/actions/shipmentExecutionActions';
import { addNewCourierPartner, addTracking, getElegibleCouriersPartners } from 'src/api/shipmentExecution';
import { useGenericState } from 'src/Library/UseGenericState';
import { FormComponentProps } from 'antd/lib/form';
import { CourierPartner, StylesProps } from 'src/Library/Types';
import { ExecutionDetails } from '../SEDetails/shipment-details.types';
import { useState } from 'react';
import { interactive } from 'src/design-system/mixins';
const FormItem = Form.Item;

const styles = theme => ({
    hintHeader: {
        fontSize: theme.fontSize.small,
        fontWeight: theme.fontWeight.semibold,
        color: '#262626',
        textAlign: 'left',
        paddingTop: '6px',
        lineHeight: 1.2
    },
    label: {
        fontSize: theme.fontSize.small,
        color: theme.colors.text,
        fontWeight: theme.fontWeight.semibold,
        display: 'flex',
        alignItems: 'center',
        height: 36,
    },
    required: {
        color: '#EB2727',
    },
    form: {
        display: 'grid',
        gridTemplateColumns: '1fr 4fr',
        '& .ant-form-item': {
            width: '100% !important',
            marginTop: 0,
        },
        ...interactive.antFormRequiredHide,
        '& .ant-form-item-label': {
            lineHeight: '26px',
        },
        '& .ant-form-explain': {
            fontSize: 10,
        },
    },
});

type IProps = ReduxProps & FormComponentProps & StylesProps<ReturnType<typeof styles>> & {
    data: ExecutionDetails;
    isVisible: boolean;
    onClose: () => void;
};

const SEAddCourierTrackingModal = (props: IProps) => {
    const {
        form,
        onClose,
        data,
    } = props;

    const [saving, setSaving] = useState<boolean>(false);
    const [refNumber, setRefNumber] = useState<string>("");
    const [courierPartner, setPartner] = useState<any>("");
    const [courierPartners, setCourierPartners] = useState<CourierPartner[]>([]);
    const { getFieldDecorator } = form;

    const { classes, isVisible } = props;

    React.useEffect(() => {
        setCourierPartnersList();
    }, [])


    const setCourierPartnersList = async () => {
        const result = await getElegibleCouriersPartners();
        setCourierPartners(result.data);
    }

    const handleAddTracking = async () => {
        setSaving(true)
        if (!refNumber || !courierPartner) {
            message.error('Please add Courier Partner and Reference number.')
            setSaving(false)
            return;
        }
        const body = {
            "courierPartnerId": courierPartner,
            "referenceNumber": refNumber,
            "shipmentId": data?.id
        }
        const result = await addNewCourierPartner(body);
        if (result?.isSuccess) {
            message.success(`Courier reference number ${refNumber} is created.`)
            setSaving(false);
        } else {
            message.error(result?.errorMessage || "Something went wrong, please try later.");
            setSaving(false);
        }
        onClose();
    }

    const awbNumberInput = () => {
        return (
            <Input
                placeholder={'Referece Number'}
                onChange={(val) => {
                    setRefNumber(val.target.value);
                }}
                allowClear
            />
        );
    }

    const getModalLabel = (text, required: boolean = true) => {
        return <span
            className={classes.hintHeader}>
            {text}
            {required && (<span className={classes.required}>
                *
            </span>)}
        </span>;
    };

    const renderAddCourier = () => {
        return (
            <Form
                hideRequiredMark={true}
            >
                <FormItem
                    colon={false}
                    label={getModalLabel("Courier Partner", true)}
                >   
                    {
                        getFieldDecorator('courierPartner', {
                            rules: [{required: true, message: 'Courier Partner is required' }]
                        })(
                            <Select
                                placeholder="Courier Partner"
                                onChange={(e) => {
                                    setPartner(e)
                                }
                                }
                                style={{ width: "100%" }}
                            >
                                {courierPartners.map((item) => {
                                    return <Select.Option
                                        value={item?.courierorgid}
                                    >
                                        {item?.name}
                                    </Select.Option>
                                })}
                            </Select>
                        )
                    }
                </FormItem>
                <FormItem
                    colon={false}
                    label={getModalLabel("Reference Number", true)}
                >
                    {
                        getFieldDecorator('referenceNumber', {
                            rules: [{required: true, message: 'Courier Refernce number is required' }]
                        })(
                            awbNumberInput()
                        )
                    }
                </FormItem>
            </Form>
        );
    };


    return (<>
        <Modal title={'Add Courier Tracking'}
            centered
            visible={isVisible} width={380} okText="Submit"
            onCancel={() => props.onClose()}
            destroyOnClose
            onOk={() => handleAddTracking()}
            footer={[
                <Button key="back" onClick={() => props.onClose()}>Cancel</Button>,
                <Button loading={saving}
                    key="confirm" type="primary" onClick={() => handleAddTracking()}
                > Submit</Button>,
            ]}
            // zIndex={1060}
            confirmLoading={true}
        >
            {renderAddCourier()}
        </Modal>
    </>);

}

const mapDispatchToProps = (dispatch) => (bindActionCreators({
    fetchTrackingData,
    enableLoadTracking,
    disableLoadTracking,
}, dispatch));

const mapStateToProps = ({ masterData }) => ({
    airlineList: masterData.globalAirLines,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

const SEAddACourierTrackingModalStyled = withStyles(styles)(Form.create()(SEAddCourierTrackingModal));
export default withRouter(connector(SEAddACourierTrackingModalStyled));
